if (!window.customElements.get("floating-recently-viewed")) {
  class FloatingRecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
    }

    connectedCallback() {
      // Check page type - only show on index and collection pages
      const pageType = this.getAttribute('data-page-type');
      if (pageType !== 'index' && pageType !== 'collection') {
        this.style.display = 'none';
        return;
      }

      // Check for A/B testing via query parameter
      const urlParams = new URLSearchParams(window.location.search);
      const recentlyViewedParam = urlParams.get('recently_viewed');
      
      // Only show if parameter is explicitly "1", hide otherwise
      if (recentlyViewedParam !== '1') {
        this.style.display = 'none';
        return;
      }

      const query = this.buildQuery();
      if (!query) {
        this.style.display = 'none';
        return;
      }
      
      this.initializeEventListeners();
      this.loadProducts(query).then(() => {
        const loadingEl = this.querySelector('.floating-rv-loading');
        if (loadingEl) loadingEl.remove();
      });
    }

    buildQuery() {
      const items = JSON.parse(localStorage.getItem("recently-viewed") || "[]");
      const excludeId = this.getAttribute("exclude-id");
      if (excludeId) {
        const index = items.indexOf(parseInt(excludeId));
        if (index !== -1) items.splice(index, 1);
      }
      return items.slice(0, this.productLimit).map(id => `id:${id}`).join(" OR ");
    }

    async loadProducts(query) {
      try {
        const url = `${window.Shopify.routes.root}search?q=${query}&resources[limit]=10&resources[type]=product&section_id=${this.sectionId}`;
        const response = await fetch(url);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const products = doc.querySelector('floating-recently-viewed .floating-rv-products');
        
        if (products?.hasChildNodes()) {
          const container = this.querySelector('.floating-rv-products');
          if (container) container.innerHTML = products.innerHTML;
        }
      } catch (error) {
        console.error('Error loading products:', error);
      }
    }

    initializeEventListeners() {
      this.querySelector('[data-rv-toggle]')?.addEventListener('click', () => this.openPanel());
      this.querySelector('[data-rv-close]')?.addEventListener('click', () => this.closePanel());
      this.querySelector('[data-rv-panel]')?.addEventListener('click', (e) => {
        if (e.target.dataset.rvPanel !== undefined) this.closePanel();
      });
    }

    openPanel() {
      const panel = this.querySelector('[data-rv-panel]');
      const toggle = this.querySelector('[data-rv-toggle]');
      const container = this.querySelector('.floating-rv-products');
      
      panel?.classList.add('active');
      toggle?.classList.add('hidden');
      document.body.classList.add('floating-rv-open');
      this.isOpen = true;
      
      if (container && !container.hasChildNodes()) {
        container.innerHTML = '<div class="floating-rv-loading">Loading...</div>';
      }
    }

    closePanel() {
      this.querySelector('[data-rv-panel]')?.classList.remove('active');
      this.querySelector('[data-rv-toggle]')?.classList.remove('hidden');
      document.body.classList.remove('floating-rv-open');
      this.isOpen = false;
    }

    get sectionId() {
      return this.getAttribute("section-id");
    }

    get productLimit() {
      return parseInt(this.getAttribute("products-limit")) || 5;
    }
  }

  window.customElements.define("floating-recently-viewed", FloatingRecentlyViewed);
}
